import { FeatureFlag } from 'types/features';
import { useHasPermissions } from 'utils/permissionUtil';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

export interface DebriefingPermissions {
    moduleEnabled: boolean;
    canRead: boolean;
    canCreate: boolean;
    canUpdate: boolean;
    canDelete: boolean;
    canExport: boolean;
    canReadConfidential: boolean;
}

export function useDebriefingPermissions(): DebriefingPermissions {
    const moduleEnabled = useIsFeatureEnabled(FeatureFlag.DEBRIEFING_MODULE);
    return {
        moduleEnabled,
        canRead: useHasPermissions(['READ.DEBRIEFINGS.ALL']) && moduleEnabled,
        canCreate: useHasPermissions(['CREATE.DEBRIEFINGS']) && moduleEnabled,
        canUpdate: useHasPermissions(['UPDATE.DEBRIEFINGS']) && moduleEnabled,
        canDelete: useHasPermissions(['DELETE.DEBRIEFINGS']) && moduleEnabled,
        canExport: useHasPermissions(['EXPORT.DEBRIEFINGS']) && moduleEnabled,
        canReadConfidential: useHasPermissions(['READ.DEBRIEFINGS.CONFIDENTIAL.ALL']) && moduleEnabled,
    };
}
